import React, { lazy } from 'react';
import { Navigate, Route } from 'react-router';
import { RequirePermission } from '@routes/RequirePermission';
import { PERMISSIONS } from '@auth/permissions';

const ManageCompetitionsOverview = lazy(() =>
  import('@pages/Management/Competitions/Competitions/Overview').then((m) => ({
    default: m.CompetitionsOverview,
  }))
);

const UpsertCompetition = lazy(() =>
  import('@pages/Management/Competitions/Competitions/UpsertCompetition').then(
    (m) => ({
      default: m.UpsertCompetition,
    })
  )
);

const CompetitionDetails = lazy(() =>
  import('@pages/Management/Competitions/Competitions/CompetitionDetails').then(
    (m) => ({
      default: m.CompetitionDetails,
    })
  )
);

const CompetitionSessionDetails = lazy(() =>
  import('@pages/Management/Competitions/Competitions/CompetitionSessionDetails').then(
    (m) => ({
      default: m.CompetitionSessionDetails,
    })
  )
);

const DisciplinesOverview = lazy(() =>
  import('@pages/Management/Competitions/Disciplines/Overview').then((m) => ({
    default: m.DisciplinesOverview,
  }))
);

const UpsertDiscipline = lazy(() =>
  import('@pages/Management/Competitions/Disciplines/UpsertDiscipline').then(
    (m) => ({
      default: m.UpsertDiscipline,
    })
  )
);

const DisciplineDetails = lazy(() =>
  import('@pages/Management/Competitions/Disciplines/DisciplineDetails').then(
    (m) => ({
      default: m.DisciplineDetails,
    })
  )
);

const CompetitionsLandingPage = lazy(() =>
  import('./landingPages/CompetitionsLandingPage').then((m) => ({
    default: m.CompetitionsLandingPage,
  }))
);

export const manageCompetitions = (
  <Route path="competitions">
    <Route index element={<CompetitionsLandingPage />} />

    <Route
      element={
        <RequirePermission permission={PERMISSIONS.competitions.view} />
      }
    >
      <Route path="overview">
        <Route index element={<ManageCompetitionsOverview />} />

        <Route
          element={
            <RequirePermission permission={PERMISSIONS.competitions.create} />
          }
        >
          <Route path="new" element={<UpsertCompetition />} />
        </Route>

        <Route
          element={
            <RequirePermission permission={PERMISSIONS.competitions.update} />
          }
        >
          <Route path="edit/:slug" element={<UpsertCompetition />} />
        </Route>

        <Route
          path=":slug/sessions/:sessionId"
          element={<CompetitionSessionDetails />}
        />
        <Route path=":slug" element={<CompetitionDetails />} />
      </Route>
    </Route>

    <Route
      element={
        <RequirePermission
          permission={PERMISSIONS.competitions.disciplines.view}
        />
      }
    >
      <Route path="disciplines">
        <Route index element={<Navigate to="overview" replace />} />
        <Route path="overview">
          <Route index element={<DisciplinesOverview />} />

          <Route
            element={
              <RequirePermission
                permission={PERMISSIONS.competitions.disciplines.create}
              />
            }
          >
            <Route path="new" element={<UpsertDiscipline />} />
          </Route>

          <Route
            element={
              <RequirePermission
                permission={PERMISSIONS.competitions.disciplines.update}
              />
            }
          >
            <Route path="edit/:slug" element={<UpsertDiscipline />} />
          </Route>

          <Route path=":slug" element={<DisciplineDetails />} />
        </Route>
      </Route>
    </Route>
  </Route>
);
